import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useAbsenModel} from "@/stores/models/absen-model";
import {useAbsenListModel} from "@/stores/models/absen-list-model";

export const useAbsenStore = defineStore(
    'absenStore',
    () => {
       
        const isLoading = ref(false);
        // const dataSourceAbsen = ref(
        //     new DataSource({
        //         requireTotalCount: true,
        //         store: useAbsenModel().absenCustomStore,
        //     })
        // );

        const dataSourceAbsenList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useAbsenListModel().absenListCustomStore,
                filter: null,
            })
        );

        const dataSourceAbsen = (additionalParams = null) => {
            
            return new DataSource({
              requireTotalCount: true,
              load: (loadOptions) => {
                // Handle load options and additionalParams separately
                return useAbsenModel().absenCustomStore.load([loadOptions, additionalParams]);
              }
            });
        };
        
        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            // dataSourceAbsen.value.reload();
            dataSourceAbsenList.value.reload();
        };

        const initialized = ()=>{     
            dataSourceAbsen.value.reload();
        };

        return {
            dataSourceAbsen,
            dataSourceAbsenList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);